



















































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { GoalModel, IGoal } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal, BvModalEvent } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import GoalForm from '@/forms/GoalForm.vue';
import { GoalApi } from '@/services/GoalApi';
import dayjs from 'dayjs';

@Component({
  components: {
    GoalForm,
    FormSubmit,
    CircleIcon,
    DiscIcon,
    CalendarIcon,
    XIcon,
  },
})
export default class EditGoalModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: true, type: Object })
  selectedGoal!: IGoal;

  @Prop({ required: false, type: String, default: 'agency' })
  readonly type!: IGoal['type'];

  model = this.defaultModel();

  defaultModel(): GoalModel {
    return {
      ...this.selectedGoal,
    };
  }

  @Watch('selectedGoal')
  watchSelectedGoal() {
    this.model = {
      ...this.selectedGoal,
    };
  }

  async mounted() {
    this.$root.$on('bv::modal::hide', async (bvEvent: BvModalEvent, modalId: string) => {
      if (modalId === 'edit-fiv-goal' && bvEvent.trigger === 'esc') {
        await this.cancel();
      }
    });
  }

  async destroyed() {
    this.$root.$off('bv::modal::hide');
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await GoalApi.updateGoal(this.model.id!, {
        name: this.model.name!,
        user: this.model.user!,
        from: dayjs(this.model.from!).startOf('day').toDate(),
        to: dayjs(this.model.to!).endOf('day').toDate(),
        type: this.type!,
        valueType: this.model.valueType!,
        value: Number(this.model.value!),
        products: this.model.products!,
        agency: this.model.agency,
        policyType: this.model.policyType,
      });

      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$toastr.s(`Ziel ${this.model.name} erfolgreich bearbeitet.`, 'Ziel bearbeitet');
      this.$nextTick(() => {
        (this.$refs['edit-goal'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Ziels ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    console.log(apiErrors['nameisNotEmpty']);
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen gültigen Namen eingeben.');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }

  cancelDeletion() {
    //
  }

  async confirmDeletion() {
    try {
      await GoalApi.delete(this.model.id!);

      (this.$refs['edit-goal'] as BModal).hide();
      this.$emit('reload');

      this.$toastr.s(`Ziel ${this.model.name} erfolgreich gelöscht.`, 'Ziel gelöscht');
    } catch (e) {
      this.$toastr.e('Beim Löschen des Ziels ist etwas schief gelaufen.');
      throw e;
    }
  }
}
